interface Props {
  className?: string;
  /** Altura en píxeles. El ancho se ajusta automáticamente por el aspect ratio del SVG. */
  altura?: number;
}

/**
 * Logo oficial Adelante (marca geométrica en verdes #ADD010 y #88A024).
 *
 * El SVG vive en `web/public/logo-adelante.svg` para tener una fuente única
 * de verdad — el favicon y los PDFs también lo consumen desde ahí.
 */
export function LogoAdelante({ className, altura = 24 }: Props) {
  return (
    <img
      src="/logo-adelante.svg"
      alt="Logo Adelante"
      height={altura}
      style={{ height: altura, width: 'auto' }}
      className={className}
    />
  );
}
